import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	background: #f3f2f9;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	padding: 20px 20px 30px 20px;
`;

export const LogoWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 20px;
`;

export const Img = styled.img`
	width: 23px;
	height: 23px;
	margin-right: 6px;
`;

export const Title = styled.h3`
	color: #1a1a1a;
	font-size: 15px;
	font-weight: 500;
`;

export const SubTitle = styled.h4`
	color: #000;
	text-align: center;
	font-size: 32px;
	font-weight: 700;
	line-height: 41px;
	letter-spacing: 0.37px;
	margin-bottom: 0;

	span {
		background: linear-gradient(to left, rgba(255, 0, 204, 1) 0%, rgba(51, 51, 153, 1) 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
`;
